import { FC, useEffect } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { CleverTapBaseData } from "../../utils/CleverTap";
import { isEmpty } from "lodash";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import {
  Abcd_Super_App_Lob_Id,
  DEVICE_TYPE,
  HiDestinationLobId,
  HomeLoansDestinationLobId,
  LiDestinationLobId,
  LoansDestinationLobId,
  MfDestinationLobId,
  OneLoginLobCode,
  SsDestinationLobId,
} from "../../utils/constants";
import { useLazySaveCustomerNavigationQuery } from "../Feature_GeneralAppElements/GeneralAppElements_Api";

const CleverTapComp: FC = () => {
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const [saveCustomerNavigationApi] = useLazySaveCustomerNavigationQuery();
  useEffect(() => {
    saveCustomerNavigationApi({ eventName: CleverTapBaseData.lastEventFired });
  }, [CleverTapBaseData.lastEventFired.length]);

  useEffect(() => {
    const onboardingChannelId =
      csAppSlice.channel === E_ChannelOptions.SUPER_APP
        ? Abcd_Super_App_Lob_Id
        : csAppSlice.channel === E_ChannelOptions.ONE_ABC
        ? OneLoginLobCode
        : csAppSlice.channel === E_ChannelOptions.ABSLI
        ? LiDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABHI
        ? HiDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABSLAMC
        ? MfDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABML
        ? SsDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABHFL
        ? HomeLoansDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABFL
        ? LoansDestinationLobId
        : "";
    const primaryUserCII =
      userDetails?.IS_USER_REGISTERED &&
      userDetails?.customerAndLobDetails?.find(
        (f) => f.PRIMARY_SECONDARY_USER === "primary"
      )?.CII;
    const clientID = csAppSlice.csUserId || userDetails?.CS_USER_ID || "";
    CleverTapBaseData.setBaseData({
      ChannelID: isEmpty(onboardingChannelId) ? "26" : "",
      UserAge: "",
      UserGender: "",
      ClientID: clientID,
      GoldenID: primaryUserCII || "",
      GuestID: "",
      $CleverTap_user_id: "",
      AppsflyerID: "",
      PlatformKey: isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName)
        ? DEVICE_TYPE.WEB
        : DEVICE_TYPE.MOBILE,
    });
  }, [
    csAppSlice?.userDetails?.IS_USER_REGISTERED,
    csAppSlice?.userDetails?.customerAndLobDetails,
    csAppSlice?.csUserId,
    csAppSlice?.NativeDeviceInfo?.deviceName,
  ]);
  return <></>;
};
export default CleverTapComp;
